<nz-page-header title="Регистрация"/>
<section class="mb-5 container-lg">
  <div class="alert alert-primary rounded-3 shadow">
    <h5>Успешно възстановяване на парола!</h5>
    <div class="pb-2">
      Вашата парола е възстановена успешно. Моля, използвайте новата парола за вход в системата.
    </div>
    <hr>
    <div>
      <a aria-label="Вход"
         class="btn btn-nz-primary"
         [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.login]">
        Вход
      </a>
    </div>
  </div>
</section>
